import React from "react";
import { type FreefieldInputProps } from "shared/utils/freeFields/models";
import NumberInput, { type NumericValue } from "components/NumberInput";

const FreefieldInteger = (props: FreefieldInputProps) => {
  const [value, setValue] = React.useState(props.initialValue);

  const onChange = (newValue: NumericValue) => {
    setValue(newValue.formatted);
    props.onChange(newValue.value?.toString() ?? "");
  };

  return <NumberInput
    value={value}
    onChanged={onChange}
    canBeEmpty
    canBeNegative
    maxLength={10}
    decimalPoints={0}
    width={90}
  />;
};

export default FreefieldInteger;